import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as upcomingProductsForSomeoneElseState from '../employee-detail.reducer';
import * as upcomingProductsForSomeoneElseReducer from '../reducers/upcoming-products-for-someone-else.reducer';

export const getUpcomingProductsForSomeoneElse = createSelector(
  upcomingProductsForSomeoneElseState.getUpcomingProductsForSomeoneElseState,
  upcomingProductsForSomeoneElseReducer.getUpcomingProductsForSomeoneElseResponse
);
